'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _FormContext = require('../context/FormContext'),
    _FormContext2 = _interopRequireDefault(_FormContext);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var FormControl = function (_Component) {
  function FormControl(props) {
    _classCallCheck(this, FormControl);

    var _this = _possibleConstructorReturn(this, (FormControl.__proto__ || Object.getPrototypeOf(FormControl)).call(this, props));

    return _this.state = {
      checked: !1,
      checkedFormControlValue: !1,
      focused: !1,
      invalid: !1,
      touched: !1,
      value: ''
    }, _this.focus = _this.focus.bind(_this), _this.handleBlur = _this.handleBlur.bind(_this), _this.handleChange = _this.handleChange.bind(_this), _this.handleFocus = _this.handleFocus.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.reset = _this.reset.bind(_this), _this.validate = _this.validate.bind(_this), _this;
  }

  return _inherits(FormControl, _Component), _createClass(FormControl, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          checkedProp = _props.checked,
          defaultCheckedProp = _props.defaultChecked,
          defaultValueProp = _props.defaultValue,
          type = _props.type,
          valueProp = _props.value,
          checked = this.getChecked(checkedProp),
          defaultChecked = this.getChecked(defaultCheckedProp),
          defaultValue = this.getValue(defaultValueProp),
          value = this.getValue(valueProp),
          usesChecked = 'checkbox' === type || 'radio' === type;
      this.isControlled = usesChecked ? void 0 !== checked : void 0 !== value, usesChecked ? this.setState({
        defaultChecked: defaultChecked,
        checkedFormControlValue: this.isControlled ? checked : void 0,
        checked: checked
      }) : this.setState({
        defaultValue: defaultValue,
        value: this.isControlled ? value : void 0
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var checked = this.getChecked(nextProps.checked),
          value = this.getValue(nextProps.value);
      this.setState({
        checkedFormControlValue: checked,
        checked: checked,
        value: value
      });
    }
  }, {
    key: 'getChecked',
    value: function getChecked(checked) {
      return null !== checked && checked;
    }
  }, {
    key: 'getValue',
    value: function getValue(value) {
      return null === value ? '' : value;
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.nativeFormControl.focus();
    }
  }, {
    key: 'reset',
    value: function reset() {
      var type = this.props.type;
      this.setState({
        invalid: !1,
        touched: !1
      }), ('checkbox' === type || 'radio' === type) && this.setState({
        checked: !1
      }), this.isControlled || ('checkbox' === type || 'radio' === type ? this.nativeFormControl.checked = !1 : this.nativeFormControl.value = ''), this.handleValidate({
        valid: !0
      });
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      this.handleValidate(this.nativeFormControl.validity, {
        callback: callback
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var _this2 = this,
          validity = event.target.validity,
          onFormControlBlur = this.props.onFormControlBlur,
          touched = this.state.touched;

      this.setState({
        focused: !1,
        touched: !0
      }, function () {
        touched || _this2.handleValidate(validity);
      }), onFormControlBlur && onFormControlBlur(event);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var _this3 = this,
          input = event.target,
          checked = input.checked,
          type = input.type,
          validity = input.validity,
          value = input.value,
          onFormControlChange = this.props.onFormControlChange,
          touched = this.state.touched;

      if (('checkbox' === type || 'radio' === type) && this.setState({
        checked: checked
      }), this.isControlled) {
        var updatedState = {};
        'checkbox' === type || 'radio' === type ? updatedState.checkedFormControlValue = checked : updatedState.value = value, this.setState(updatedState, function () {
          touched && _this3.handleValidate(validity);
        });
      }

      onFormControlChange && onFormControlChange(event), !this.isControlled && touched && this.handleValidate(validity);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFormControlFocus = this.props.onFormControlFocus;
      this.setState({
        focused: !0
      }), onFormControlFocus && onFormControlFocus(event);
    }
  }, {
    key: 'handleNativeFormControlRef',
    value: function handleNativeFormControlRef(node) {
      var nativeFormControlRef = this.props.nativeFormControlRef;
      this.nativeFormControl = node, this.nativeFormControl && this.registerFormControl && this.registerFormControl({
        focus: this.focus,
        id: this.nativeFormControl.id,
        reset: this.reset,
        validate: this.validate
      }), nativeFormControlRef && nativeFormControlRef(node);
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate(validity, options) {
      var _this4 = this,
          onValidate = this.props.onValidate;

      onValidate(validity, options, _extends({
        updateValidationState: function updateValidationState(valid, validationMessage, onValidateCallback) {
          _this4.setState({
            invalid: !valid,
            touched: !0
          }), onValidateCallback && onValidateCallback(valid, validationMessage);
        }
      }, this.state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this,
          _state = this.state,
          checked = _state.checked,
          checkedFormControlValue = _state.checkedFormControlValue,
          defaultChecked = _state.defaultChecked,
          defaultValue = _state.defaultValue,
          focused = _state.focused,
          invalid = _state.invalid,
          value = _state.value;

      return _react2.default.createElement(_FormContext2.default.Consumer, null, function (registerFormControl) {
        return _this5.registerFormControl = registerFormControl, _this5.props.render({
          checked: checked,
          checkedFormControlValue: checkedFormControlValue,
          defaultChecked: defaultChecked,
          defaultValue: defaultValue,
          focused: focused,
          invalid: invalid,
          handleBlur: _this5.handleBlur,
          handleChange: _this5.handleChange,
          handleFocus: _this5.handleFocus,
          handleNativeFormControlRef: _this5.handleNativeFormControlRef,
          value: value
        });
      });
    }
  }]), FormControl;
}(_react.Component);

FormControl.propTypes = {
  checked: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  defaultValue: function defaultValue(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if ('string' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, or a value of `null`.');
    }
  },
  nativeFormControlRef: _propTypes2.default.func,
  onFormControlBlur: _propTypes2.default.func,
  onFormControlChange: _propTypes2.default.func,
  onFormControlFocus: _propTypes2.default.func,
  onValidate: _propTypes2.default.func,
  render: _propTypes2.default.func,
  type: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, FormControl.defaultProps = {}, FormControl.displayName = 'FormControl', FormControl.WrappedComponent = FormControl, exports.default = FormControl;